export class ParametroPaginacionGenerico {

    registroInicio: number;
    cantidadRegistrosDevolver: number;
    registroEncontrados: number;
    listaResultado: any[];

    atributoOrdenar: string;
    direccionOrdenAtributo: any;
}
